import { useState } from "react";
import "./ReviewsSlider.css";

function ReviewsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const reviews = [
    { name: "Ashutosh Gaikwad", date: "June 19 2026", review: "Excellent quality gym wear." },
    { name: "Rana Karnail", date: "June 19 2026", review: "Very comfortable products." },
    { name: "RISHI KHATRI", date: "June 19 2026", review: "Amazing fabric quality." },
    { name: "Deepak Khabole", date: "June 16 2026", review: "Worth every rupee." },
    { name: "Chand Faridi", date: "June 15 2026", review: "Excellent." },
    { name: "Rahul", date: "June 14 2026", review: "Awesome products" },
    { name: "Aman", date: "June 13 2026", review: "Very good quality" },
    { name: "Vikas", date: "June 12 2026", review: "Loved it" },
  ];

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  const currentReview = reviews[currentIndex];

  return (
    <section className="reviews-section">
      <div className="reviews-header">
        <h2>GymWear</h2>
        <div className="rating-row">
          <span className="rating-number">4.5</span>
          <span className="stars">★★★★★</span>
          <span className="review-count">1876 Reviews</span>
          <span className="google">Google</span>
        </div>
      </div>

      {/* Single Review Card - Mobile First */}
      <div className="slider-container">
        <button className="nav-arrow prev" onClick={goToPrev}>❮</button>

        <div className="review-card">
          <div className="avatar">{currentReview.name.charAt(0)}</div>
          <div className="stars-small">★★★★★</div>
          <h3>{currentReview.name}</h3>
          <p className="date">{currentReview.date}</p>
          <p className="review-text">{currentReview.review}</p>
        </div>

        <button className="nav-arrow next" onClick={goToNext}>❯</button>
      </div>

      {/* Optional: Dots */}
      <div className="dots">
        {reviews.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(idx)}
          />
        ))}
      </div>
    </section>
  );
}

export default ReviewsSlider;